import { menuAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(menuAnatomy.keys)

// define custom variants
const variants = {
	requestReferences: {
		button: {
			fontWeight: '500',
			bg: 'white',
			color: 'black',

			fontSize: '0.85rem',
			border: '1px solid #009B76',
			borderRadius: '17px',
			padding: '0.5rem 0.875rem',
		},
		list: {
			bg: 'white',
		},
		item: {
			color: 'brand.700',
			pl: '1.5rem',
		},
		groupTitle: {
			letterSpacing: 'wider',
		},
	},
	roundRight: {},
}

// export the custom variants in the component theme
export const MenuStyle = defineMultiStyleConfig({ variants })
